import { render, staticRenderFns } from "./SoccerCover_c1.vue?vue&type=template&id=5ca60efa&"
import script from "./SoccerCover_c1.vue?vue&type=script&lang=js&"
export * from "./SoccerCover_c1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports